export * from "@ttp/common/config";
export * from "@ttp/common/keys";
export * from "@ttp/common/types";

export type HelloWorldType = {
  hello: true;
  world: true;
  string: "hello world";
};
